import {useTranslation} from 'react-i18next';
import {useSnackbar} from 'notistack';
import {validateNodes} from "nodeEditor/utils/NodeValidation";

export const useNodeEditorValidator = () => {
    const {t} = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const isValid = (editor: object | undefined): boolean => {

        const nodeErrors: Array<string> = validateNodes(editor);
        if (nodeErrors.length !== 0) {
            enqueueSnackbar(t("lessonEditor.errorFixNodeEditorIssues"), {
                anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                variant: 'error'
            });

            let errMsg = "";
            nodeErrors.forEach(e => {
                errMsg += `- ${e}\n`
            });
            alert(errMsg);
            return false;
        }

        return true;

    }

    return {isValid};
}